import { render, staticRenderFns } from "./WorkSummaryViewFilters.yaml?vue&type=template&id=08d5313a&component"
import script from "./WorkSummaryViewFilters.yaml?vue&type=script&lang=ts&component"
export * from "./WorkSummaryViewFilters.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports